"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stepperVerticalModule = _interopRequireDefault(require("./sass/stepperVertical.module.scss"));

var _iconsReact = require("@carbon/icons-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepperVertical = function StepperVertical(_ref) {
  var stepsArray = _ref.stepsArray,
      colorCircle = _ref.colorCircle,
      colorComplete = _ref.colorComplete,
      _ref$colorDisabled = _ref.colorDisabled,
      colorDisabled = _ref$colorDisabled === void 0 ? '#C6CAD1' : _ref$colorDisabled;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: _stepperVerticalModule.default.steps
  }, stepsArray.map(function (Component, index) {
    var isCompleted = Component.props.isCompleted;
    var isDisabled = Component.props.isDisabled;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "".concat(_stepperVerticalModule.default.steps_step),
      "data-testid": "stepID"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _stepperVerticalModule.default.steps_step_circle,
      style: {
        background: isDisabled ? colorDisabled : isCompleted ? colorComplete : colorCircle
      }
    }, isCompleted ? /*#__PURE__*/_react.default.createElement(_iconsReact.Checkmark16, null) : index + 1), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: '4px'
      }
    }, Component));
  }));
};

StepperVertical.propTypes = {
  stepsArray: _propTypes.default.arrayOf(_propTypes.default.node)
};
var _default = StepperVertical;
exports.default = _default;